<template>
  <div class="tours-page">

    <div class="space-y-4 mx-auto px-2 pb-4 pt-4 w-full">
      <!-- Logo -->
      <div v-if="settings?.logo">
        <div class="block text-center w-[80%] m-auto my-4">
          <img class="mt-[25vh] max-h-[150px] max-w-full m-auto" :src="settings.logo.preview_url" />
        </div>
      </div>

      <!-- Introduction text -->
      <div class="min-h-[64px]">
        <div v-if="settings && (settings.introduction_title || settings.introduction_text)"
             class="px-4 py-4"
             :style="{ color: settings.text_color }">
          <div v-if="settings.introduction_title" class="block text-center font-bold mb-2">
            {{ showMultiLingualText(settings.introduction_title, null, true) }}
          </div>
          <div v-if="settings.introduction_text" class="text-center leading-5">
            {{ showMultiLingualText(settings.introduction_text, null, true) }}
          </div>
        </div>
      </div>


    </div>


    <div class="flex flex-1 min-h-[6em] mx-2 my-2" v-if="!loading">
      <div v-if="tours.length > 0" class="space-y-4">
        <div v-for="tour in tours" :key="tour.id" class="tour-item">
          <TourListItem :tour="tour" :params="params"  :style="{ color: settings.text_color }" />
        </div>
      </div>
      
      <div v-else class="text-center py-8 w-full" :style="{ color: settings.text_color }">
        <p>{{ $t('no_tours') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../services/api'
import TourListItem from '../components/TourListItem.vue'
import {showMultiLingualText} from "@/vue/utils/languageUtils";

export default {
  name: 'VueTours',
  components: {
    TourListItem
  },
  props: ['settings'],
  data() {
    return {
      tours: [],
      loading: true,
      params: {}
    }
  },
  async mounted() {
    // Load tours
    await this.loadTours()
  },
  methods: {
    showMultiLingualText(text, altText = null, showFirstLanguage = false) {
      return showMultiLingualText(text, altText, showFirstLanguage, this.$i18n.locale)
    },

    async loadTours() {
      this.loading = true
      try {
        const response = await api.fetchTourList()
        if (response?.data) {
          this.tours = response.data
          console.log('Tours loaded:', this.tours)
        } else {
          console.log("no active tours found, redirect to not-found")
          this.$router.push({ name: "not-found", query: { ...this.$route.query } })
        }
      } catch (error) {
        console.error('Error loading tours:', error)
        // Redirect to not-found page on error
        this.$router.push({ name: "not-found", query: { ...this.$route.query } })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>